import * as React from 'react';
import { BoxSelectionSelectionType } from './types';

export const NativeSelectorContext =
  React.createContext<BoxSelectionSelectionType>(
    BoxSelectionSelectionType.RADIO_BUTTON,
  );

export const NativeSelectorProvider = NativeSelectorContext.Provider;

export const NativeSelectorConsumer = NativeSelectorContext.Consumer;
